function storeyToSortOrder(storey: string | undefined): number {
  if (storey === undefined) {
    return Number.NEGATIVE_INFINITY
  }

  const numericStorey = Number(storey)
  return Number.isNaN(numericStorey) ? Number.NEGATIVE_INFINITY : numericStorey
}

function buildSlabToStoreyMapping(
  slabs: Array<{ guid: string; storey?: string }>,
): Record<string, string> {
  return Object.fromEntries(
    slabs.filter(slab => slab.storey != null).map(slab => [slab.guid, slab.storey as string]),
  )
}

function sortWindLoadResultIndicesByStorey(
  results: WindloadCeilingResult[],
  slabToStorey: Record<string, string>,
): number[] {
  return results
    .map((_, index) => index)
    .sort(
      (indexA, indexB) =>
        storeyToSortOrder(slabToStorey[results[indexB].slab_guid]) -
        storeyToSortOrder(slabToStorey[results[indexA].slab_guid]),
    )
}

export { buildSlabToStoreyMapping, sortWindLoadResultIndicesByStorey }
